/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ExceptionData } from './ExceptionData';
import {
    ExceptionDataFromJSON,
    ExceptionDataFromJSONTyped,
    ExceptionDataToJSON,
} from './ExceptionData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100UnprocessableContentException
 */
export interface Ptw100UnprocessableContentException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnprocessableContentException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnprocessableContentException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {ExceptionData}
     * @memberof Ptw100UnprocessableContentException
     */
    data?: ExceptionData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100UnprocessableContentException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnprocessableContentException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnprocessableContentException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100UnprocessableContentException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnprocessableContentException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100UnprocessableContentException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100UnprocessableContentException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof Ptw100UnprocessableContentException
     */
    $type?: Ptw100UnprocessableContentExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100UnprocessableContentExceptionTypeEnum = {
    PtwPtw100AppZeroCoreSharedExceptionsPtw100UnprocessableContentExceptionPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100UnprocessableContentException, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type Ptw100UnprocessableContentExceptionTypeEnum = typeof Ptw100UnprocessableContentExceptionTypeEnum[keyof typeof Ptw100UnprocessableContentExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100UnprocessableContentException interface.
 */
export function instanceOfPtw100UnprocessableContentException(value?: unknown): value is Ptw100UnprocessableContentException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100UnprocessableContentExceptionTypeEnum)[0];
}

export function Ptw100UnprocessableContentExceptionFromJSON(json: any): Ptw100UnprocessableContentException {
    return Ptw100UnprocessableContentExceptionFromJSONTyped(json, false);
}

export function Ptw100UnprocessableContentExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100UnprocessableContentException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExceptionDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100UnprocessableContentExceptionToJSON(value?: Omit<Ptw100UnprocessableContentException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': ExceptionDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        '$type': value['$type'],
    });
}

